import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailTwoToneIcon from "@mui/icons-material/MailTwoTone";
import DraftsTwoToneIcon from "@mui/icons-material/DraftsTwoTone";
import "./Notification.scss";
import CloseIcon from "@mui/icons-material/Close";
import { Grid, Modal, Typography } from "@mui/material";
import {
  useNotificationService,
  useAddReadStatusService,
} from "../../services/notifications/service";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

const modelStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function NotificationDrawer(props: any) {
  const { open, onCloseNotification, sentData } = props;
  const [opennotificationModel, setOpennotificationModel] =
    React.useState(false);
  const [selectedNotificationItem, setselectedNotificationItem] =
    useState(Object);
  const storedData = localStorage.getItem("customerInfo");
  const customerInfo = storedData ? JSON.parse(storedData) : {};
  const NotificationGetPayloadData = {
    email: customerInfo?.sourceEmail,
    accountNumber: customerInfo?.customerAccountNumber,
  };
  const handleOpen = (item: any) => {
    setOpennotificationModel(true);
    setselectedNotificationItem(item);
    if (item.userEmail == null || item.userEmail == "") {
      const ReadStatusPayloadData = {
        userEmail: customerInfo?.sourceEmail,
        notificationSentToId: item.notificationSentToId,
      };
      AddNotificationReadStatus(ReadStatusPayloadData);
      setTimeout(() => {
        fetchAllNotifications(NotificationGetPayloadData);
      }, 100);
    }
  };

  const handleClose = () => {
    setOpennotificationModel(false);
    setselectedNotificationItem(null);
  };

  const { notificationList, fetchAllNotifications } = useNotificationService();
  const { message, AddNotificationReadStatus } = useAddReadStatusService();
  
  dayjs.extend(utc);
  dayjs.extend(tz);
  const timeZone = dayjs.tz.guess();

  useEffect(() => {
    fetchAllNotifications(NotificationGetPayloadData);
  }, [fetchAllNotifications]);

  useEffect(() => {
    sentData(notificationList.filter((user) => user.userEmail == null).length);
  });

  const DrawerList = (
    <Box sx={{ width: 350 }} role="presentation">
      <List>
        {["Notifications"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton sx={{ pointerEvents: "none" }}>
              <ListItemText primary={text} />
            </ListItemButton>
            <ListItemIcon
              onClick={onCloseNotification}
              style={{ textAlign: "right" }}
            >
              <CloseIcon style={{ cursor: "pointer" }} />
            </ListItemIcon>
          </ListItem>
        ))}
      </List>
      <Divider />
      {notificationList.length == 0 && (
        <List sx={{ maxHeight: "150px", paddingTop: 0 }}>
          <ListItem key="0" disablePadding>
            <ListItemButton sx={{ pointerEvents: "none" }}>
              <ListItemText primary="No New Notifications!!!" />
            </ListItemButton>
          </ListItem>
        </List>
      )}
      <List
        className="all-notification-content"
        sx={{
          maxHeight: `${
            notificationList.length > 5
              ? 450
              : notificationList.length * 100 + 60
          }px`,
        }}
      >
        {notificationList?.map((item: any, index: number) => (
          <ListItem
            key={item.title}
            disablePadding
            className="notification-list-item"
            onClick={() => handleOpen(item)}
            style={
              item.userEmail != null
                ? { backgroundColor: "white" }
                : { backgroundColor: "#ddd" }
            }
          >
            <ListItemButton sx={{ pointerEvents: "none" }}>
              <ListItemIcon>
                {item.userEmail != null ? (
                  <MailTwoToneIcon />
                ) : (
                  <DraftsTwoToneIcon />
                )}
              </ListItemIcon>

              <ListItemText
                primary={item.title}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{ color: "text.secondary", display: "inline" }}
                    >
                      {dayjs
                        .utc(item.sentDate)
                        .tz(timeZone)
                        .format("MM/DD/YYYY, hh:mm A")}
                    </Typography>
                  </React.Fragment>
                }
              />
              
            </ListItemButton>
            <ListItemButton sx={{ pointerEvents: "none" }}>
              <ListItemText
                className="notification-content"
                primary={
                  <React.Fragment>
                    <Typography
                      component="div"
                      variant="body2"
                      sx={{ color: "text.secondary", display: "inline" }}
                    >
                      {item?.content?.split('\n').map((line: any, index: number) => (
                        index == 0?
                        <React.Fragment key={index}>
                          {line.slice(0, 45)}... 
                          
                        </React.Fragment>
                      :null))}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItemButton>
            <React.Fragment>
              <Divider />
            </React.Fragment>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer
        open={open}
        anchor="right"
        sx={{
          marginTop: "100px",
          maxHeight: `${
            notificationList.length > 5
              ? 500
              : notificationList.length == 0
              ? 100
              : notificationList.length * 100 + 60
          }px`,
        }}
        className="notification-drawer"
      >
        {DrawerList}
      </Drawer>

      <Modal
        className="notificationmodel"
        open={opennotificationModel}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modelStyle}>
          <div className="notificationheader">
            <Grid container spacing={2}>
              <Grid size={11}>
                <Typography id="modal-modal-title" variant="h6" component="h1">
                  {selectedNotificationItem?.title}
                </Typography>
                <Typography id="modal-modal-date" variant="h6" component="h5">
                    {dayjs
                        .utc(selectedNotificationItem?.sentDate)
                        .tz(timeZone)
                        .format("MM/DD/YYYY, hh:mm A")}
                </Typography>
              </Grid>
              <Grid size={1}>
                <CloseIcon
                  onClick={handleClose}
                  className="notification-model-close"
                />
              </Grid>
            </Grid>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {selectedNotificationItem?.content?.split('\n').map((line:any, index:number) => (
              <React.Fragment key={index}>
                {line}
                {index < selectedNotificationItem?.content?.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
